import { EquippedSurface } from '../../../../Sections/properties';
import { getEnumObjectDiffOptionRows, getEnumObjectIdenticalOptionRows } from '../../optionRowData';

/**
 * Returns all identical options
 *
 * @param planValue
 * @param liveValue
 * @return {{key: string, left: *, right: *}[]}
 */
export const getIdenticalEquippedSurfaceOptionRows = (planValue, liveValue) => {
    return getEnumObjectIdenticalOptionRows(EquippedSurface, planValue, liveValue);
};

/**
 * Returns all options which are
 *
 * @param planValue
 * @param liveValue
 * @return {{key: string, left: *, right: *}[]}
 */
export const getDiffEquippedSurfaceOptionRows = (planValue, liveValue) => {
    return getEnumObjectDiffOptionRows(EquippedSurface, planValue, liveValue);
};
